import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router/index.js'
import './styles/global.css'
import 'amfe-flexible'
import animated from 'animate.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Notice from './components/Message/message.js'
import { Swipe, SwipeItem } from 'vant'
// import 'vant/lib/index.css'
import 'vant/lib/swipe/style/less'
Vue.prototype.$notice = Notice

console.log(router)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(animated)
Vue.use(VueAxios, axios)
Vue.use(Swipe)
Vue.use(SwipeItem)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
